import {
  FiCheckCircle,
  FiShoppingBag,
  FiUsers,
  FiXCircle
} from 'react-icons/fi'
import SimpleModal from 'components/SimpleModal'
import { CustomButton } from 'styles/global'
import { PreviaClientesPorLoja } from 'store/modules/backoffice/campanha/types'

interface ModalAprovacaoClientesProps {
  isOpen: boolean
  totalClientes: number
  clientesPorLoja: PreviaClientesPorLoja[]
  onAprovar: () => void
  onReprovar: () => void
  disableAprovar?: boolean
  showAvisoPreviaMista?: boolean
}

const ModalAprovacaoClientes = ({
  isOpen,
  totalClientes,
  clientesPorLoja,
  onAprovar,
  onReprovar,
  disableAprovar = false,
  showAvisoPreviaMista = false
}: ModalAprovacaoClientesProps) => {
  return (
    <SimpleModal
      isOpen={isOpen}
      toggle={() => onReprovar()}
      dataBackdrop="static"
      header="Confirmação de clientes"
      footer={
        <div className="modal-aprovacao-clientes modal-aprovacao-clientes--footer">
          <div className="d-flex justify-content-center">
            <div className="modal-aprovacao-clientes__actions">
              <CustomButton
                background="var(--branco)"
                border="1px solid var(--vermelho-riber)"
                color="var(--vermelho-riber)"
                borderRadius={16}
                height="40px"
                onClick={onReprovar}
              >
                <FiXCircle className="action-icon" /> Reprovar
              </CustomButton>
              <CustomButton
                background="var(--verde-riber)"
                borderRadius={16}
                height="40px"
                isDisabled={disableAprovar}
                onClick={() => {
                  if (disableAprovar) return
                  onAprovar()
                }}
              >
                <FiCheckCircle className="action-icon" /> Aprovar
              </CustomButton>
            </div>
          </div>
        </div>
      }
    >
      <div className="modal-aprovacao-clientes">
        <label className="modal-aprovacao-clientes__subtitle">
          Revise os clientes disponíveis por loja antes de continuar.
        </label>

        <div className="modal-aprovacao-clientes__divider" />

        <div className="modal-aprovacao-clientes__total">
          <FiUsers /> {totalClientes} clientes encontrados
        </div>

        {disableAprovar && (
          <div className="modal-aprovacao-clientes__warning">
            Não há clientes disponíveis para os parâmetros selecionados.
          </div>
        )}

        {showAvisoPreviaMista && (
          <div className="modal-aprovacao-clientes__warning">
            Lojas ou grupos sem clientes serão desconsiderados após a aprovação.
          </div>
        )}

        <div className="modal-aprovacao-clientes__list">
          {clientesPorLoja.map((item) => (
            <div
              key={`${item.lojaId}-${item.nomeLoja}`}
              className="modal-aprovacao-clientes__item"
            >
              <div className="modal-aprovacao-clientes__item-left">
                <div className="modal-aprovacao-clientes__icon">
                  <FiShoppingBag />
                </div>
                <span className="modal-aprovacao-clientes__name">
                  {item.nomeLoja}
                </span>
              </div>
              <span className="modal-aprovacao-clientes__qtde">
                {item.quantidadeClientes}
              </span>
            </div>
          ))}
        </div>
      </div>
    </SimpleModal>
  )
}

export default ModalAprovacaoClientes
